// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__25VUL","rightAdornment":"Header_rightAdornment__3ASj2"};